import React from 'react';
import styles from '../Components/Footer.module.css';

export default function Footer() {
    return (
        <div className={styles.footer}>
            <div className={styles.heading}>
                <h2>
                    Shital Paints<sup><i class="fa-regular fa-registered"></i></sup>
                </h2>
            </div>
            <div className={styles.content}>
                <div className={styles.description}>
                    <h4>Description</h4>
                    <p>
                        Shital Paints, established as a Proprietor firm in 2005, is a leading manufacturer, wholesaler, and trader of a wide range of Wall Primer, Interior Emulsion, Exterior Emulsion Paint, etc. Located in Ahmedabad, Gujarat, we have a well-functional infrastructural unit that plays an essential role in our company's growth. We offer these products at reasonable rates and deliver within the promised time frame. Under the headship of Mr. Mukesh Rathod, we have gained a huge clientele across the nation.
                    </p>
                </div>
                <div className={styles.whyUs}>
                    <h4>Why Us?</h4>
                    <ul>
                        <li>Quality assured product range</li>
                        <li>Adept team of professionals</li>
                        <li>Ethical business policies</li>
                        <li>Client-centric approach</li>
                        <li>Large distribution network</li>
                        <li>Transparent dealings</li>
                        <li>Excellent transport & logistic facility</li>
                        <li>Reasonable prices</li>
                    </ul>
                </div>
                <div className={styles.details}>
                    <h4 className={styles.address}>Address</h4>
                    <p>
                        Shital Paints, <br />1, Suyog Complex, Drive In Road, Memnagar, Ahmedabad-380052, Gujarat, India
                    </p>
                    <h4 className={styles.mobile}>Mobile</h4>
                    <p>
                        <a href="tel:+919904157082">+91 9904157082</a>
                    </p>
                    <h4 className={styles.mail}>Email</h4>
                    <p>
                        <a href="mailto:shitalPaints@gmail.com">shitalPaints@gmail.com</a>
                    </p>
                </div>
            </div>
            <footer>
                <hr />© 2022 ShitalPaints.
            </footer>
        </div>
    );
}
